import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import type { EmpAddressVm, EmpAddressListItem, EmpAddressListResponse } from '@/api/types'

export class EmpAddressService {
  async getAll(
    branchId: number,
    empId: number,
    pageNumber = 1,
    pageSize = 10
  ): Promise<EmpAddressListResponse> {
    const url = endpoints.empAddress.getAll(branchId, empId, pageNumber, pageSize)
    const res = await apiClient.get<EmpAddressListResponse | { data: EmpAddressListItem[] }>(url)
    const raw = res.data as any

    if (raw && Array.isArray(raw.data)) {
      return {
        data: raw.data,
        totalRecords: raw.totalRecords ?? raw.data.length ?? 0,
        pageNumber: raw.pageNumber ?? pageNumber,
        pageSize: raw.pageSize ?? pageSize,
      }
    }

    if (Array.isArray(raw)) {
      return {
        data: raw as EmpAddressListItem[],
        totalRecords: (raw as EmpAddressListItem[]).length,
        pageNumber,
        pageSize,
      }
    }

    return { data: [], totalRecords: 0, pageNumber, pageSize }
  }

  async getById(id: number): Promise<EmpAddressVm> {
    const url = endpoints.empAddress.getById(id)
    const res = await apiClient.get<EmpAddressVm | { data: EmpAddressVm }>(url)
    const raw = res.data as any
    if (raw && typeof raw === 'object' && 'data' in raw) return raw.data as EmpAddressVm
    return raw as EmpAddressVm
  }

  async getByEmpId(empId: number): Promise<EmpAddressListItem[]> {
    const url = endpoints.empAddress.getByEmpId(empId)
    const res = await apiClient.get<EmpAddressListItem[] | { data: EmpAddressListItem[] }>(url)
    const raw = res.data as any
    if (Array.isArray(raw)) return raw as EmpAddressListItem[]
    if (raw && typeof raw === 'object' && 'data' in raw && Array.isArray(raw.data)) {
      return raw.data as EmpAddressListItem[]
    }
    return []
  }

  async create(payload: EmpAddressVm): Promise<unknown> {
    const url = endpoints.empAddress.create
    const res = await apiClient.post(url, payload)
    return res.data
  }

  async update(payload: EmpAddressVm): Promise<unknown> {
    const url = endpoints.empAddress.update
    const res = await apiClient.put(url, payload)
    return res.data
  }

  async delete(id: number): Promise<void> {
    const url = endpoints.empAddress.delete(id)
    await apiClient.delete(url)
  }
}

export const empAddressService = new EmpAddressService()

